export class EnrollmentFormatsConstants{
    public static readonly FormatName_Open: string = 'Open';
    public static readonly FormatClassName_Open: string = 'open';
    public static readonly FormatName_Closed: string = 'Closed';
    public static readonly FormatClassName_Closed: string = 'closed';
    public static readonly FormatClassName_PartialFilled: string = 'partial-open';
    public static readonly FormatClassName_full: string = 'full';
    public static readonly Technical_Error_On_Session_Attendees:string = 'Technical error : Failed to fetch the session attendees due to a timeout. Please contact Technical support for further assistance.'
    public static readonly Technical_Error_On_Users_List:string = 'No users found for this session.'
}